export default function isDefined(value) {
    return typeof value !== 'undefined';
}
